/**
 * mapProducerToShareTarget — normalizes producer/farm data into a ShareTarget.
 * Canonical data sources:
 *   - producers → name, slug, id, short_description
 *   - media_assets → cover image (via useCoverAsset)
 *   - places → place name (optional)
 *
 * Image priority (handled by caller via useCoverAsset):
 *   1. producer cover asset (media_assets kind='cover', owner_type='producer')
 *   2. producer gallery asset
 *   3. null → Share Studio renders branded fallback
 */

import type { ProducerShareTarget } from '../ShareTarget';

interface ProducerMapperInput {
  producerId: string;
  producerName: string;
  producerSlug: string;
  /** Resolved from media_assets — NOT from any legacy field */
  heroImageUrl?: string | null;
  /** Short description / tagline */
  tagline?: string | null;
  /** Place/venue name if available */
  placeName?: string | null;
}

export function mapProducerToShareTarget(input: ProducerMapperInput): ProducerShareTarget {
  const { producerId, producerName, producerSlug, heroImageUrl, tagline, placeName } = input;

  return {
    type: 'producer',
    id: producerId,
    slug: producerSlug,
    title: `Välkommen till ${producerName}`,
    heroImageUrl: heroImageUrl ?? null,
    producerName,
    producerSlug,
    producerId,
    tagline: tagline?.trim().slice(0, 160) || null,
    placeName: placeName ?? null,
  };
}
